<template>
  <div class="minePage">
    <!-- 个人信息 start -->
    <div class="clumn_wrap">
      <div class="tit">
        个人信息
        <span @click="handleShowDialog(1)"
          ><i class="iconfont icon-bianji1"></i
        ></span>
      </div>
      <el-descriptions title="">
        <el-descriptions-item label="姓名">{{
          userInfo.truename
        }}</el-descriptions-item>
        <el-descriptions-item label="工作手机">{{
          tuozhanInfo.mobile
        }}</el-descriptions-item>
        <el-descriptions-item label="工作微信">{{
          tuozhanInfo.weixin
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{
          userInfo.sex ? userInfo.sex : ""
        }}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{
          userInfo.age ? userInfo.age : ""
        }}</el-descriptions-item>
        <el-descriptions-item label="所在地区">{{
          PCA_address
        }}</el-descriptions-item>
      </el-descriptions>

      <!-- 个人信息编辑 start -->
      <el-dialog title="个人信息编辑" :visible.sync="dialogUserEdit">
        <div class="el-dialog-div">
          <el-form
            :model="formDateUserEdit"
            label-position="top"
            ref="formDateUserEdit"
            :rules="ruleFormDateUserEdit"
          >
            <el-form-item label="昵称" prop="nickname">
              <el-input
                v-model="formDateUserEdit.nickname"
                placeholder="请输入昵称"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="truename">
              <el-input
                v-model="formDateUserEdit.truename"
                placeholder="请输入用户"
              ></el-input>
            </el-form-item>
            <el-form-item label="工作手机" prop="mobile">
              <el-input
                v-model="formOtherData.mobile"
                placeholder="请输入工作手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="工作微信" prop="weixin">
              <el-input
                v-model="formOtherData.weixin"
                placeholder="请输入工作微信"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-select
                v-model="formDateUserEdit.sex"
                placeholder="请选择性别"
              >
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年龄" prop="age">
              <el-input
                v-model="formDateUserEdit.age"
                placeholder="请输入年龄"
              ></el-input>
            </el-form-item>

            <el-form-item label="所在地">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-select
                    v-model="userInfo.provincename"
                    @change="handleProvinceChange"
                    @focus="getProvince()"
                    placeholder="选择省/直辖市"
                  >
                    <el-option
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
                      v-for="item in provinceList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userInfo.cityname"
                    placeholder="选择城市"
                    @focus="getCity()"
                    @change="handleCityChange"
                  >
                    <el-option
                      :key="item.cityid"
                      :label="item.cityname"
                      :value="item.cityid"
                      v-for="item in cityList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userInfo.areaname"
                    @change="handleAreaChange"
                    @focus="getArea()"
                    placeholder="选择所在区域"
                  >
                    <el-option
                      :key="item.addrid"
                      :label="item.addrname"
                      :value="item.addrid"
                      v-for="item in areaList"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="" prop="addr">
              <el-input
                type="textarea"
                v-model="formDateUserEdit.addr"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogUserEdit = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="medium"
            @click="handleUserEdit('formDateUserEdit')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 个人信息编辑 end -->
    </div>
    <!-- 个人信息 end -->

    <!-- 企业信息 start -->
    <div class="clumn_wrap">
      <div class="tit">
        企业信息
        <span
          @click="dialogCompanyEdit = true"
          v-if="userCompanyCard.checkrole == '创建人'"
          ><i class="iconfont icon-bianji1"></i
        ></span>
      </div>
      <div v-if="userCompanyCard.id && isLoad">
        <template v-if="userCompanyCard.checkstate == '审核中'">
          <div class="operation flex-rowl">
            <el-button type="primary" plain @click="handleGo(2)"
              >企业申请加入中</el-button
            >
          </div>
        </template>
        <template v-else>
          <el-descriptions title="">
            <el-descriptions-item label="企业名称">{{
              userCompanyCard.qyname
            }}</el-descriptions-item>
            <el-descriptions-item label="企业名称英文/缩写">{{
              userCompanyCard.qyename
            }}</el-descriptions-item>
            <el-descriptions-item label="所属部门">{{
              userCompanyCard.deptname
            }}</el-descriptions-item>
            <el-descriptions-item label="角色关系">{{
              userCompanyCard.rolename
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{
              userCompanyCard.linkname
            }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{
              userCompanyCard.linkphone
            }}</el-descriptions-item>
            <el-descriptions-item label="联系邮箱">{{
              userCompanyCard.linkemail
            }}</el-descriptions-item>
            <el-descriptions-item label="社会统一信用代码">{{
              userCompanyCard.uscc
            }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="">
            <el-descriptions-item label="官方抖音ID">{{
              userCompanyCard.douyinid
            }}</el-descriptions-item>
            <el-descriptions-item label="官方小红书ID">{{
              userCompanyCard.redbookid
            }}</el-descriptions-item>
            <el-descriptions-item label="官方大众点评ID">{{
              userCompanyCard.dianpingid
            }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="">
            <el-descriptions-item label="所在地区"
              >{{ userCompanyCard.provincename }}{{ userCompanyCard.cityname
              }}{{ userCompanyCard.arearname }}</el-descriptions-item
            >
            <el-descriptions-item label="详细地址">{{
              userCompanyCard.addr
            }}</el-descriptions-item>
          </el-descriptions>
          <div v-if="userCompanyCard.checkrole == '创建人'">
            <el-button type="primary" @click="dialogCompanyEdit = true"
              >企业/团队信息管理</el-button
            >
            <el-button type="primary" @click="handleGo(3)">成员管理</el-button>
          </div>
          <div class="operation flex-rowl" v-else>
            <el-button type="primary">退出企业</el-button>
          </div>
        </template>
      </div>
      <div class="no_data" v-if="!userCompanyCard.id && isLoad">
        <el-button type="primary" @click="dialogCompanyEdit = true"
          >创建企业/团队名片</el-button
        >
        <el-button type="primary" @click="handleGo(1)"
          >加入企业or团队</el-button
        >
      </div>

      <!-- 企业信息编辑 start -->
      <el-dialog title="企业信息编辑" :visible.sync="dialogCompanyEdit">
        <div class="el-dialog-div">
          <el-form
            :model="formCompany"
            label-position="top"
            ref="formCompany"
            :rules="ruleFormDateCompanyEdit"
          >
            <el-form-item label="企业/团队名称" prop="qyname">
              <el-input
                v-model="formCompany.qyname"
                placeholder="请输入企业名称，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="LOGO缩略图" prop="logo">
              <div
                class="upload_box"
                @mouseenter="creenIndex = 1"
                @mouseleave="creenIndex = ''"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :http-request="beforeAvatarUpload"
                >
                  <div v-if="formCompany.logo">
                    <img :src="formCompany.logo" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formCompany.logo)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="formCompany.logo = ''"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="企业/团队名称英文" prop="qyename">
              <el-input
                v-model="formCompany.qyename"
                placeholder="请输入企业名称英文或缩写，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="linkname">
              <el-input
                v-model="formCompany.linkname"
                placeholder="请输入联系人名称，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="linkphone">
              <el-input
                v-model="formCompany.linkphone"
                placeholder="请输入联系电话，20个字符内"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱" prop="linkemail">
              <el-input
                v-model="formCompany.linkemail"
                placeholder="请输入联系邮箱，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属行业">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.label1_name"
                    @change="handleLabel1Change"
                    @focus="getQyFirstLevelLabel()"
                    placeholder="请选择一级行业标签"
                  >
                    <el-option
                      :key="item.id"
                      :label="item.labelname"
                      :value="item.id"
                      v-for="item in oneLabelList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.label2_name"
                    placeholder="请选择二级行业标签"
                    @focus="getQyTwoLevelLabel()"
                    @change="handleLabel2Change"
                  >
                    <el-option
                      :key="item.id"
                      :label="item.labelname"
                      :value="item.id"
                      v-for="item in twoLabelList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.label3_name"
                    @change="handleLabel3Change"
                    @focus="getQyThreeLevelLabel()"
                    placeholder="请选择三级行业标签"
                  >
                    <el-option
                      :key="item.id"
                      :label="item.labelname"
                      :value="item.id"
                      v-for="item in threeLabelList"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="所在地">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.provincename"
                    @change="handleProvinceChange"
                    @focus="getProvince()"
                    placeholder="选择省/直辖市"
                  >
                    <el-option
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
                      v-for="item in provinceList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.cityname"
                    placeholder="选择城市"
                    @focus="getCity()"
                    @change="handleCityChange"
                  >
                    <el-option
                      :key="item.cityid"
                      :label="item.cityname"
                      :value="item.cityid"
                      v-for="item in cityList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.arearname"
                    @change="handleAreaChange"
                    @focus="getArea()"
                    placeholder="选择所在区域"
                  >
                    <el-option
                      :key="item.addrid"
                      :label="item.addrname"
                      :value="item.addrid"
                      v-for="item in areaList"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="" prop="addr">
              <el-input
                type="textarea"
                v-model="formCompany.addr"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系社会统一信用代码人" prop="uscc">
              <el-input
                v-model="formCompany.uscc"
                placeholder="请输入统一社会信用代码，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="营业执照副本副本扫描件" prop="logo">
              <div
                class="upload_box"
                @mouseenter="creenIndex = 2"
                @mouseleave="creenIndex = ''"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :http-request="beforeAvatarUpload"
                >
                  <div v-if="formCompany.pic">
                    <img :src="formCompany.pic" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 2"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formCompany.pic)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="formCompany.pic = ''"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="官方抖音ID" prop="douyinid">
              <el-input
                v-model="formCompany.douyinid"
                placeholder="请输入官方抖音ID，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="官方小红书ID" prop="redbookid">
              <el-input
                v-model="formCompany.redbookid"
                placeholder="请输入官方小红书ID，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="官方大众点评ID" prop="dianpingid">
              <el-input
                v-model="formCompany.dianpingid"
                placeholder="请输入官方大众点评ID，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogCompanyEdit = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="medium"
            @click="handleCompanyEdit('formCompany')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 企业信息编辑 end -->
    </div>
    <!-- 企业信息 end -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserInfo,
  getProvince,
  getCity,
  getArea,
  uploadImage,
} from "../api/api";
import { updateUserInfo, updateUserExtInfo } from "../api/user";
import {
  getCompanyInfo,
  editCompany,
  getQyFirstLevelLabel,
  getQyTwoLevelLabel,
  getQyThreeLevelLabel,
} from "../api/company";
export default {
  name: "mine",
  data() {
    var validateUserName = (rule, value, callback) => {
      // 6-18位中英文、数字组合
      let reg2 = /^[a-zA-Z0-9\u4e00-\u9fa5]{2,20}$/;
      if (!reg2.test(value)) {
        callback(new Error("姓名格式错误，请输入2-20位中英、数字组合"));
      } else {
        callback();
      }
    };
    var validateUserAge = (rule, value, callback) => {
      // 6-18位中英文、数字组合
      let reg2 = /^[0-9]{0,3}$/;
      if (!reg2.test(value)) {
        callback(new Error("年龄格式错误，请输入0-3位数字"));
      } else {
        callback();
      }
    };
    var validateUserAddr = (rule, value, callback) => {
      if (value.length > 50) {
        callback(new Error("地址格式错误，请输入0-50位任意字符"));
      } else {
        callback();
      }
    };
    return {
      PCA_address: "",
      userInfo: "",
      tuozhanInfo: "",
      dialogUserEdit: false,
      formDateUserEdit: {
        openid: "",
        headimg: "",
        nickname: "",
        truename: "",
        sex: "",
        age: "",
        province: "",
        city: "",
        area: "",
        addr: "",
      },
      // 扩展信息
      formOtherData: {
        openid: "",
        mobile: "",
        weixin: "",
        mobile2: "",
        intro: "",
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      ruleFormDateUserEdit: {
        truename: [{ validator: validateUserName, trigger: "blur" }],
        age: [{ validator: validateUserAge, trigger: "blur" }],
        addr: [{ validator: validateUserAddr, trigger: "blur" }],
      },

      dialogCompanyEdit: false,
      isLoad: false,
      userCompanyCard: "",
      formCompany: {
        openid: "",
        qyname: "",
        qyename: "",
        logo: "",
        uscc: "",
        linkname: "",
        linkphone: "",
        linkemail: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        label1: "",
        label2: "",
        label3: "",
        douyinid: "",
        redbookid: "",
        dianpingid: "",
        pic: "",
      },
      ruleFormDateCompanyEdit: {
        qyname: [
          {
            required: true,
            message: "请输入企业名称，30个字符内",
            trigger: "blur",
          },
        ],
        qyename: [
          {
            required: true,
            message: "请输入企业名称英文或缩写，30个字符内",
            trigger: "blur",
          },
        ],
        linkname: [
          {
            required: true,
            message: "请输入联系人名称，30个字符内",
            trigger: "blur",
          },
        ],
        uscc: [
          {
            required: true,
            message: "请输入统一社会信用代码，30个字符内",
            trigger: "blur",
          },
        ],
      },
      //   一级标签
      oneLabelList: [],
      //   二级标签
      twoLabelList: [],
      // 三级标签
      threeLabelList: [],
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    this.getInit();
    this.getCompanyInfo();
  },
  methods: {
    async getInit() {
      // 获取用户
      let res1 = this.$store.state.USERINFO;
      this.userInfo = res1;
      if (res1.provincename) {
        this.PCA_address =
          (res1.provincename ? res1.provincename : "") +
          " " +
          (res1.cityname ? res1.cityname : "") +
          " " +
          (res1.areaname ? res1.areaname : "") +
          " " +
          (res1.addr ? res1.addr : "");
      }
      this.tuozhanInfo = res1.tuozhan.length > 0 ? res1.tuozhan[0] : "";
      this.formDateUserEdit.openid = res1.openid ? res1.openid : "";
      this.formDateUserEdit.headimg = res1.headimg ? res1.headimg : "";
      this.formDateUserEdit.nickname = res1.nickname ? res1.nickname : "";
      this.formDateUserEdit.truename = res1.truename ? res1.truename : "";
      this.formDateUserEdit.age = res1.age ? res1.age : "";
      this.formDateUserEdit.sex = res1.sex ? res1.sex : "";
      this.formDateUserEdit.province = res1.province ? res1.province : "";
      this.formDateUserEdit.area = res1.area ? res1.area : "";
      this.formDateUserEdit.city = res1.city ? res1.city : "";
      this.formDateUserEdit.addr = res1.addr ? res1.addr : "";

      this.formOtherData.openid = res1.openid ? res1.openid : "";
      this.formOtherData.mobile2 = res1.mobile ? res1.mobile : "";
      if (res1.tuozhan.length > 0) {
        this.formOtherData.weixin = res1.tuozhan[0].weixin
          ? res1.tuozhan[0].weixin
          : "";
        this.formOtherData.mobile = res1.tuozhan[0].mobile
          ? res1.tuozhan[0].mobile
          : "";
        this.formOtherData.intro = res1.tuozhan[0].intro
          ? res1.tuozhan[0].intro
          : "";
      }
    },
    // 获取用户信息
    getUserInfo() {
      let openid = this.$store.state.OPENID;
      getUserInfo({ openid }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
          this.getInit();
        }
      });
    },

    // 获取企业信息
    getCompanyInfo() {
      let openid = this.$store.state.OPENID;
      getCompanyInfo({ openid }).then((res) => {
        this.formCompany.openid = openid;
        if (!res.result) {
          this.userCompanyCard = res;
          this.formCompany.qyname = res.qyname;
          this.formCompany.qyename = res.qyename;
          this.formCompany.logo = res.logo;
          this.formCompany.uscc = res.uscc;
          this.formCompany.linkname = res.linkname;
          this.formCompany.linkphone = res.linkphone;
          this.formCompany.linkemail = res.linkemail;
          this.formCompany.province = res.province;
          this.formCompany.city = res.city;
          this.formCompany.area = res.area;
          this.formCompany.addr = res.addr;
          this.formCompany.label1 = res.label1;
          this.formCompany.label2 = res.label2;
          this.formCompany.label3 = res.label3;
          this.formCompany.douyinid = res.douyinid;
          this.formCompany.redbookid = res.redbookid;
          this.formCompany.dianpingid = res.dianpingid;
          this.formCompany.pic = res.pic;
        }
        this.isLoad = true;
      });
    },

    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.provinceList = res;
      });
    },
    // 获取城市
    getCity() {
      getCity(this.formDateUserEdit.province).then((res) => {
        this.cityList = res;
      });
    },
    // 获取区域
    getArea() {
      getArea(this.formDateUserEdit.city).then((res) => {
        this.areaList = res;
      });
    },
    // 获取企业一级标签
    getQyFirstLevelLabel() {
      getQyFirstLevelLabel().then((res) => {
        this.oneLabelList = res;
      });
    },
    // 获取二级标签
    getQyTwoLevelLabel() {
      getQyTwoLevelLabel(this.formCompany.label1).then((res) => {
        this.twoLabelList = res;
      });
    },
    // 获取三级标签
    getQyThreeLevelLabel() {
      getQyThreeLevelLabel(this.formCompany.label2).then((res) => {
        this.threeLabelList = res;
      });
    },

    // 显示弹窗
    handleShowDialog(type) {
      if (type == 1) {
        this.dialogUserEdit = true;
      }
    },
    // 下拉选择省市
    handleProvinceChange(e) {
      let { dialogCompanyEdit, dialogUserEdit } = this;
      // 个人地址
      if (dialogUserEdit) {
        this.formDateUserEdit.province = e;
        this.formDateUserEdit.city = "";
        this.userInfo.cityname = "";
        this.formDateUserEdit.area = "";
        this.userInfo.areaname = "";
      }
      // 企业地址
      if (dialogCompanyEdit) {
        this.formCompany.province = e;
        this.formCompany.city = "";
        this.userCompanyCard.cityname = "";
        this.formCompany.area = "";
        this.userCompanyCard.arearname = "";
      }

      this.getCity();
    },
    // 下拉选择城市
    handleCityChange(e) {
      let { dialogCompanyEdit, dialogUserEdit } = this;
      if (dialogUserEdit) {
        this.formDateUserEdit.city = e;
        this.formDateUserEdit.area = "";
        this.userInfo.areaname = "";
      }
      if (dialogCompanyEdit) {
        this.formCompany.city = e;
        this.formCompany.area = "";
        this.userCompanyCard.arearname = "";
      }

      this.getArea();
    },
    // 下拉选择区域
    handleAreaChange(e) {
      let { dialogCompanyEdit, dialogUserEdit } = this;
      if (dialogUserEdit) {
        this.formDateUserEdit.area = e;
      }
      if (dialogCompanyEdit) {
        this.formCompany.area = e;
      }
    },

    // 修改个人数据
    async handleUserEdit() {
      let params = this.formDateUserEdit;
      let params1 = this.formOtherData;
      let res1 = await updateUserInfo(params);
      let res2 = await updateUserExtInfo(params1);
      if (res1.result && res2.result) {
        this.$message.success(res1.message);
        this.getUserInfo();
        this.dialogUserEdit = false;
      } else {
        this.$message.error(res1.message);
        this.dialogUserEdit = false;
      }
    },

    // 一级标签
    handleLabel1Change(e) {
      this.formCompany.label1 = e;
      this.formCompany.label2 = "";
      this.formCompany.label3 = "";
    },
    handleLabel2Change(e) {
      this.formCompany.label2 = e;
      this.formCompany.label3 = "";
    },
    handleLabel3Change(e) {
      this.formCompany.label3 = e;
    },
    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formCompany.logo = res.url;
          } else if (creenIndex == 2) {
            this.formCompany.pic = res.url;
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },
    // 修改企业信息
    handleCompanyEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.formCompany;
          editCompany(params).then((res) => {
            if (res.result) {
              this.$message.success(res.message);
              this.getCompanyInfo();
              this.dialogCompanyEdit = false;
            } else {
              this.$message.error(res.message);
              this.dialogCompanyEdit = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleGo(type) {
      if (type == 1) {
        this.$router.push("/companyIndex/companyList");
      } else if (type == 2) {
        this.$router.push(
          `/companyIndex/companyDetail/${this.userCompanyCard.id}`
        );
      } else if (type == 3) {
        this.$router.push(
          `/companyIndex/userList/${this.userCompanyCard.id}`
        );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.minePage {
  padding: 160px 65px;
  /deep/ .el-select {
    width: 100%;
  }
  .clumn_wrap {
    margin-bottom: 40px;
    .tit {
      font-size: 16px;
      margin-bottom: 15px;
      span {
        margin-left: 6px;
        cursor: pointer;
        .iconfont {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }
  .el-dialog-div {
    height: 55vh;
    overflow-y: scroll;
  }
}
</style>